export default __webpack_public_path__ + "static/media/Version (1) - Hobbit_06.2c60e965.jpg";